import React, { useEffect, useState } from "react";

const FinishingScheduleSummary: React.FC = () => {
    return (
        <React.Fragment>
        </React.Fragment>
    )
}

export default FinishingScheduleSummary;